// Generated by ReScript, PLEASE EDIT WITH CARE

import * as FontAwesome$Web from "./FontAwesome.res.js";
import * as Locale$LumiI18n from "lumi-i18n/lib/es6/src/Locale.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Localization$LumiI18n from "lumi-i18n/lib/es6/src/Localization.res.js";

function stopProp(handler, event) {
  event.stopPropagation();
  return handler(event);
}

function LocalePicker(props) {
  let currentLocale = Locale$LumiI18n.useContext();
  let setLocale = Localization$LumiI18n.SetLocale.useContext();
  let locales = Localization$LumiI18n.Locales.useContext();
  return JsxRuntime.jsxs("p", {
    children: [
      JsxRuntime.jsx("span", {
        children: JsxRuntime.jsx("select", {
          children: locales.map(newLocale => JsxRuntime.jsx("option", {
            children: Locale$LumiI18n.name(newLocale),
            value: Locale$LumiI18n.toString(newLocale)
          }, Locale$LumiI18n.toString(newLocale))),
          value: Locale$LumiI18n.toString(currentLocale),
          onChange: e => {
            let value = e.target.value;
            let newLocale = Locale$LumiI18n.fromString(value);
            if (newLocale !== undefined) {
              return setLocale(newLocale);
            }
          }
        }),
        className: "select"
      }),
      JsxRuntime.jsx("span", {
        children: JsxRuntime.jsx(FontAwesome$Web.Solid.make, {
          name: "language"
        }),
        className: "icon is-left"
      })
    ],
    className: "control has-icons-left",
    onClick: extra => stopProp(param => {}, extra)
  });
}

let make = LocalePicker;

export {
  stopProp,
  make,
}
/* FontAwesome-Web Not a pure module */
